import { RequestBuilder } from "../requestBuilder";
import { BlockIdParamsSchema, CreatePublicAssetRequestSchema, PublicAssetSchema } from "./publicAssetsClient.types";

// CreatePublicAssetRequestConfig creates a public PDF asset from markdown
// The body should contain markdown and optional blockId and chatId
export const CreatePublicAssetRequestConfig = new RequestBuilder({
  path: () => "/public-assets",
  bodySchema: CreatePublicAssetRequestSchema,
  responseSchema: PublicAssetSchema,
}).withMethod("POST");

// GetPublicAssetByBlockIdRequestConfig retrieves a public asset by block ID
export const GetPublicAssetByBlockIdRequestConfig = new RequestBuilder({
  path: ({ blockId }) => `/public-assets/by-block/${blockId}`,
  paramsSchema: BlockIdParamsSchema,
  responseSchema: PublicAssetSchema,
});
